import { environment, LOGIN_TIMEOUT } from "../config";
import { iUserProfile } from "../interfaces/Auth/iUserProfile";
import { DataResponseMinimalApi } from "../interfaces/DataResponseMinimalApi";
import { iDataCreditosDynamoDB } from "../interfaces/iDataCreditosDynamoDB";
import { iDataResultadoDynamoDB } from "../interfaces/iDataProyectoDynamoDB";
import { iDataProyectoPorUsuario } from "../interfaces/iDataProyectoPorUsuario";
import { iDataResultadoDB } from "../interfaces/iDataResultadoDB";
import { iDataUserLogs } from "../interfaces/iDataUserLogs";
import { DynamoUser } from "../interfaces/SuperAdmin/Others/DynamoUser";
import { iDataProyectosResultadoMap } from "../interfaces/UmmiaApps/iDataProyectosResultadoMap";
import { iPropuestaData } from "../interfaces/UmmiaApps/iPropuestaUsuario";
import { getObjectives } from "../services/apiBroker";
import {
  CloneProyect,
  CreateProyect,
  CreateResult,
  GetProyectoById,
  GetProyectosByOrganizationId,
  GetProyectosByUserId,
  GetRegistroCreditosByUserId,
  GetResultadoById,
  GetResultadoByProyectoId,
  GetUserByEmail,
  GetUserLoginLogByUserId,
  GetUserProfileByUserId,
  GetUsersWhiteList,
  PostLogRegisterActivityByUserId,
  PostProjectUserInput,
  PostRegistroCreditosByUserId,
  PostUserProfile,
  PutProyectoResultadoById,
  PutRegistroCreditosByUserId,
  PutResultadoById,
  PutUserProfile,
  updateProyectoById,
} from "../services/ApiGraphql";
import {
  suscribeOnCreateProyecto,
  suscribeOnUpdateResult,
} from "../services/suscriptionsGraphQL";
import { descubrirProyectosConResultados } from "../utils/descubrirProyectosConResultados";

/**
 * Genera la solicitud para crear un proyecto solo si la etapa es 0
 * @param {*} userId
 * @param {*} propuestaUsuario
 * @returns
 */
export const crearProyecto = async (
  userId: string,
  id_organizacion: string | null,
  proyectoId: string,
  propuestaUsuario: any,
  tipoEstructura: string
): Promise<string> => {
  console.log("propuestaUsuario", propuestaUsuario);
  const { nivel_curso, nombre, materias } = propuestaUsuario;
  console.log("materias", materias);
  const nombrePropuesta =
    nombre ?? nivel_curso + " " + "propuesta de planificación";
  const createProyectoResult = await CreateProyect(
    userId,
    id_organizacion,
    proyectoId,
    nombrePropuesta,
    tipoEstructura,
    nivel_curso,
    materias
  );
  return createProyectoResult.id;
};

/**
 * Crea un resultado asociado al proyecto Id cuando es Completado
 * @param {*} proyectoId
 * @param {*} isCompleted
 * @param {*} isFailed
 * @param {*} etapa
 * @param {*} wsProject
 */
export const crearResultado = async (
  proyectoId: string,
  isCompleted: boolean,
  isFailed: boolean,
  etapa: any,
  wsProject: any,
  promptLLM: string
): Promise<string | null> => {
  console.log(
    `crearResultado: proyectoId=${proyectoId}, isCompleted=${isCompleted}, isFailed=${isFailed}, etapa=${etapa}, wsProject=${JSON.stringify(
      wsProject
    )}`
  );

  // Validación de condiciones previas
  if (!isCompleted || isFailed || !proyectoId) {
    console.warn(
      `[crearResultado] Condiciones no cumplidas para proyectoId=${proyectoId}`
    );
    return null;
  }

  try {
    console.log(
      `isCompleted: cargando resultados en BD. etapa=${etapa}, proyectoId=${proyectoId}`
    );

    const resultado = await CreateResult(
      proyectoId,
      etapa,
      wsProject,
      promptLLM
    );
    return resultado.id;
  } catch (error) {
    console.error(
      `[crearResultado] Error al crear resultado para proyectoId=${proyectoId}:`,
      error
    );
    return null;
  }
};

export const calificarResultado = async (
  resultadoId: string,
  calificacion: number
) => {
  await PutResultadoById(resultadoId, { calificacion: calificacion });
};

export const getProyectosByUser = async (
  userId: string
): Promise<iDataProyectosResultadoMap[]> => {
  try {
    const result = await GetProyectosByUserId(userId);
    console.log("getProyectosByUser userId", userId, "result", result);

    if (result) {
      const proyectosConResultado = descubrirProyectosConResultados(result);
      return proyectosConResultado;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error getProyectosByUser", error);
    return [];
  }
};

/**
 *
 * @param userId
 */
export const suscribeProyect = async (
  userId: string
): Promise<iDataProyectosResultadoMap[] | []> => {
  try {
    const proyecto = await suscribeOnCreateProyecto(userId); // Esperamos el resultado de la suscripción
    console.log("suscribeProyect proyecto", proyecto);
    return descubrirProyectosConResultados([proyecto]);
  } catch (error) {
    console.error("Error en suscripción o procesamiento de proyectos", error);
  }
  return []; //retorna array vacio
};

export const suscribeUpdateResult = async (
  proyectoId: string
): Promise<iDataProyectosResultadoMap[] | []> => {
  try {
    const proyecto = await suscribeOnUpdateResult(proyectoId); // Esperamos el resultado de la suscripción
    console.log("suscribeUpdateResult proyecto", proyecto);
  } catch (error) {
    console.error("Error en suscripción o procesamiento de resultados", error);
  }
  return []; //retorna array vacio
};

/**
 *
 * @param proyectoId
 * @returns
 */
export const getResultadosByProyectoId = async (
  proyectoId: string
): Promise<iDataResultadoDynamoDB> => {
  return await GetResultadoByProyectoId(proyectoId);
};

/**
 *
 * @param organizacionId
 * @returns
 */
export const getProyectosByOrganizacionId = async (
  organizacionId: string
): Promise<iDataProyectosResultadoMap[]> => {
  try {
    const result = await GetProyectosByOrganizationId(organizacionId);
    if (result) {
      const proyectosConResultado = descubrirProyectosConResultados(result);
      console.log("proyectosConResultado", proyectosConResultado);
      return proyectosConResultado.filter(
        (proyecto): proyecto is iDataProyectosResultadoMap =>
          "usuario" in proyecto
      );
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error getProyectosByOrganizacionId", error);
    return [];
  }
};

/**
 * Actualiza un resultado de un proyecto con el id del resultado y le pasa el objeto modificado
 * @param {*} proyectoId
 * @param {*} proyectoObj
 * @returns
 */
export const putResultadoById = async (
  proyectoId: string,
  resultadoPropuestaId: string,
  proyectoObjPropuesta: iDataProyectoPorUsuario["propuesta"]
): Promise<iDataResultadoDB> => {
  try {
    console.log(
      `putResultadoById obj=${proyectoObjPropuesta} proyectoId=${proyectoId} resultadoPropuestaId=${resultadoPropuestaId}`
    );
    const dataResultado = await GetResultadoById(resultadoPropuestaId);
    console.log({ dataResultado });
    let resultado = JSON.parse(dataResultado.resultado);

    if (resultado.propuestas) {
      resultado.propuestas = proyectoObjPropuesta;
    } else {
      resultado = proyectoObjPropuesta;
    }

    return await PutProyectoResultadoById(resultadoPropuestaId, resultado);
  } catch (error) {
    console.error("Error putResultadoById", error);
    throw new Error("putResultadoById: problema en la solicitud");
  }
};

export const copyProjectByUser = async (
  proyectoId: string,
  usuarioId: string,
  resultadoId: string,
  proyectoObj: iDataProyectoPorUsuario["propuesta"]
) => {
  console.log({ proyectoId, usuarioId, resultadoId, proyectoObj });

  try {
    //Obtenemos el proyecto por el id
    const dataProyecto = await GetProyectoById(proyectoId);
    //desestructuramos proyecto
    const {
      asignaturas,
      name,
      nivelCurso,
      organizacionId,
      tipoEstructura,
      promptLLM,
    } = dataProyecto;
    console.log({ dataProyecto });
    //Luego el resultado por el id de resultado
    const dataResultado = await GetResultadoById(resultadoId);
    //desestructuramos resultado
    const { resultado } = dataResultado;
    console.log({ dataResultado });
    //Resultado se recibe como string se parsea a JSON
    let newResultado = JSON.parse(resultado);
    //Revisamos la estructura de respuesta ya que esta varia segun ABP, Aula Activa y UmmiaApps que se recibe del backend
    newResultado = newResultado.propuestas
      ? { ...newResultado, propuestas: proyectoObj }
      : proyectoObj;

    //Primero creamos el proyecto
    const proyectoCreado = await CloneProyect(
      usuarioId,
      organizacionId,
      proyectoId,
      name,
      tipoEstructura,
      nivelCurso,
      asignaturas
    );
    console.log({ proyectoCreado });

    //Luego cremos rel resultado
    const resultadoCreado = await CreateResult(
      proyectoCreado.id,
      dataResultado.etapa,
      newResultado,
      promptLLM
    );
    console.log({ resultadoCreado });
    return true;
  } catch (error: any) {
    throw new Error("Error en procesar la solicitud copyProjectByUser" + error);
  }
};

/**
 *
 * @param {*} userId
 * @param {*} event
 * @param {*} detail
 * @returns
 */
export const postLogRegisterActivity = async (
  userId: string,
  event: string,
  detail: string = ""
) => {
  try {
    return await PostLogRegisterActivityByUserId(userId, event, detail);
  } catch (error) {
    console.error("Error postLogRegisterActivity", error);
  }
};

/**
 *
 * @param {*} userId
 * @param {*} inTokens
 * @param {*} outTokens
 * @param {*} costo
 * @returns
 */
export const registrarCreditosUsados = async (
  userId: string,
  inTokens: number,
  outTokens: number,
  costo: number
) => {
  try {
    console.log(
      `registrarCreditosUsados userId:${userId}, inTokens:${inTokens}, outTokens:${outTokens}, costo:${costo}`
    );
    //La mejor estrategia es transformar dolares a centavos y redondear para manejar las operaciones financieras
    const creditosUsadosCentavos = Math.round(costo * 100);
    console.log({ creditosUsadosCentavos });
    const creditosUsuario = await GetRegistroCreditosByUserId(userId);
    console.log({ creditosUsuario });
    //SI el usuario ya registra creditos imputamos el valor al credito existente
    if (creditosUsuario) {
      const { creditosUsados, tokensIngresados, tokensRecibidos, id } =
        creditosUsuario;
      const nuevoCosto = creditosUsados + creditosUsadosCentavos;
      const nuevoInTokens = tokensIngresados + inTokens;
      const nuevoOutTokens = tokensRecibidos + outTokens;
      return await PutRegistroCreditosByUserId(
        id,
        nuevoInTokens,
        nuevoOutTokens,
        nuevoCosto
      );
    } else {
      //Si el usuario no tiene creditos registrados asignamos el valor inicial del costo del resultado en centavos
      return await PostRegistroCreditosByUserId(
        userId,
        inTokens,
        outTokens,
        creditosUsadosCentavos
      );
    }
  } catch (error) {
    console.error("Error registrarCreditosUsados", error);
  }
};

/**
 *
 * @param {*} userId
 * @returns
 */
export const getCreditosByUserId = async (
  userId: string
): Promise<iDataCreditosDynamoDB | null> => {
  try {
    return await GetRegistroCreditosByUserId(userId);
  } catch (error) {
    console.error("Error getCreditosByUserId", error);
    throw new Error("Error getCreditosByUserId");
  }
};

// Función para traer usuario de DynamoDB y registrar inicio de sesión
export const loginSuccess = async (
  email: string | null
): Promise<DynamoUser | null> => {
  const { REACT_APP_LOG_USER_REPORTS } = environment;
  const isLogReportsAvailable = REACT_APP_LOG_USER_REPORTS === "true";

  try {

    if(!email){
      throw new Error("Correo inexistente para buscar en DynamoDB")
    }

    const lastLoginTime = Number(localStorage.getItem("lastLoginTime"));
    const currentTime = new Date().getTime();
    const usuarioDB = await GetUserByEmail(email);

    if (!usuarioDB) {
      throw new Error("Usuario no encontrado en la base de datos DynamoDB");
    }

    const { id } = usuarioDB;

    //Unicamente se permite registrar actividad en base de datos si esta activado en las variables de entorno
    if (isLogReportsAvailable) {
      //Permitimos el registro en los logs unicamente si se sobrepasa el limite de 1 hora configurado en LOGIN_TIMEOUT
      if (lastLoginTime && currentTime - lastLoginTime < LOGIN_TIMEOUT) {
        console.log(
          "Login reciente detectado, no registraremos el acceso en logs"
        );
        return usuarioDB;
      }
      await postLogRegisterActivity(id, "LOGIN_SUCCESSFUL");
    }

    return usuarioDB;
  } catch (error: any) {
    console.error("Error en el proceso de login", error);
    throw Error(error.message);
  }
};

export const userCreditsManagement = async (
  userId: string
): Promise<number> => {
  //1 centavo equivale a 1 crédito
  const respuesta = await getCreditosByUserId(userId);
  console.log("CreditosUsados en centavos", respuesta);
  const costoCentavos = respuesta ? respuesta.creditosUsados : 0;
  return costoCentavos;
};

export const getUsersWhiteList = async () => {
  try {
    return await GetUsersWhiteList();
  } catch (error) {
    console.error("Error getUsersWhiteList", error);
  }
};

export const createUserProfile = async (
  userId: string,
  profileUserData: any
) => {
  const profile = await GetUserProfileByUserId(userId);
  console.log({ profile });

  if (profile) {
    //Si el usuario tiene su perfil creado solo actualizamos
    const respuesta: any = await PutUserProfile(profile.id, profileUserData);
    return respuesta.data.updatePerfil;
  }

  //Si el usuario no tiene perfil se lo creamos
  const respuesta: any = await PostUserProfile(userId, profileUserData);
  return respuesta.data.createPerfil;
};

/**
 *
 * @param {*} userId
 * @returns
 */
export const getUserProfile = async (
  userId: string
): Promise<iUserProfile | null> => {
  return await GetUserProfileByUserId(userId);
};

/**
 *
 * @param {*} userId
 */
export const getUserLoginLogsByUserId = async (
  userId: string,
  limit: number
): Promise<iDataUserLogs[]> => {
  return await GetUserLoginLogByUserId(userId, limit);
};

/**
 *
 * @param userId
 * @param propuestaUsuario
 * @param envoltorio
 * @param data
 * @returns
 */
export const persistirProyecto = async (
  userId: string,
  id_organizacion: string | null,
  proyectoId: string,
  propuestaUsuario: iPropuestaData,
  envoltorio: string,
  data: DataResponseMinimalApi["respuesta"],
  promptLLM: DataResponseMinimalApi["prompt"]
): Promise<{ proyectoId: string; resultadoId: string } | null> => {
  console.log("Persistiendo proyecto con:", {
    userId,
    id_organizacion,
    propuestaUsuario,
    envoltorio,
    data,
    promptLLM,
  });

  try {
    await crearProyecto(
      userId,
      id_organizacion,
      proyectoId,
      propuestaUsuario,
      envoltorio
    );
    console.log({ proyectoId });

    const resultadoId = await crearResultado(
      proyectoId,
      true,
      false,
      0,
      {
        resultado: data,
      },
      promptLLM
    );
    console.log({ resultadoId });

    return resultadoId ? { proyectoId, resultadoId } : null;
  } catch (error) {
    console.error("Error al persistir el proyecto:", error);
    return null;
  }
};

/**
 *
 * @param proyectoId
 * @param promptData
 */
export const registrarUserInput = async (
  proyectoId: string,
  promptData: any,
  etapa?: number
) => {
  try {
    return await PostProjectUserInput(proyectoId, promptData, etapa ?? 0);
  } catch (error) {
    console.error("Error al registrarUserInput el proyecto:", error);
    return null;
  }
};

export const getObjetivos = async (
  pais: string,
  asignatura: string,
  nivel: string
) => {
  return await getObjectives(pais, asignatura, nivel);
};


export const desactivarProyecto = async (proyectoId: string) => {
  //Esto no elimina en la base de datos, solo lo desactiva
  console.log("Desactivar proyecto con ID:", proyectoId);
  return await updateProyectoById(proyectoId, { isEliminated: true });
}